import { create } from 'zustand';

/** Open/close state for the settings + account overlay modal. */
interface SettingsStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSettingsModal = create<SettingsStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
